import { render, staticRenderFns } from "./CliniciansTeamsSelector.vue?vue&type=template&id=6f64aea8"
import script from "./CliniciansTeamsSelector.vue?vue&type=script&lang=js"
export * from "./CliniciansTeamsSelector.vue?vue&type=script&lang=js"
import style0 from "./CliniciansTeamsSelector.vue?vue&type=style&index=0&id=6f64aea8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports